export enum DeliveryType {
  Standard = 'standard', // 일반 배송
  Shak = 'shak', // 샥 배송
  Today = 'today', // 오늘출발
  ThirdPL = 'third_pl', // 도착보장(3PL)
  Reserved = 'reserved', // 예약판매
}
